/* 
  base class for modules
*/

class Device {
  constructor() {
    this.id = "";
    this.status = "";        
    this.name="";
    this.usbProductName = "";
    this.usbSerialNumber = "";    
    
    this.errors = [];
    this.warnings = [];
  }
  logData(logData) {
    logData.append(this.name, this.value);
  }
  async connect() {
  }
  async disconnect() {    
  }    
}

export default Device;


/*
class Device {  
  constructor(...args) {    
    this.id = "";
    this.status = "uninitialized";        
    this.name="";
    this.usbProductName = "";
    this.usbSerialNumber = ""
  }
  async connect() {
  }
  async disconnect() {    
  }  
  
}
*/

/*
class Device {
  #logdevice_handler_f = null
  constructor(...args) {    
    this.id = "";
    this.status = "uninitialized";        
  }
  async connect() {
      this.#logdevice_handler_f = this.#logdevice_handler.bind(this);
      jfermi.addEventListener("logdevice", this.#logdevice_handler_f);

      this.status = "failed";
  }
  async disconnect() {
    this.removeEventListener("logdevice", this.#logdevice_handler_f);
  }  
  #logdevice_handler(event) {    
  }  
  #updatedevice_handler(event) {    
  }  
}
*/